module.exports = "\r\n\r\n.content {\r\n  direction: rtl;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/discount/discount-add/discount-add.component.css
// module id = ./src/app/components/discount/discount-add/discount-add.component.css
// module chunks = main